/**
 * AUTO-GENERATED with npm run generateIcons
 */
import { forwardRef, ForwardRefExoticComponent, RefAttributes } from 'react';
import Icon from '@ant-design/icons';
import { IconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { classNames } from '../../helpers';

const svg = () => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.607 5.293a1 1 0 0 1 0 1.414L5.314 11h15.585a1 1 0 1 1 0 2H5.314l4.293 4.293a1 1 0 1 1-1.415 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.415 0Z"
            fill="currentColor"
        />
    </svg>
);

type Props = IconComponentProps & RefAttributes<HTMLSpanElement>;
const SvgArrowLeft: ForwardRefExoticComponent<Props> = forwardRef((props, ref) => (
    <Icon component={svg} {...props} ref={ref} className={classNames('svg-arrow-left', props.className)} />
));
export default SvgArrowLeft;
